import React from 'react'
import PropTypes from 'prop-types'
import styles from './loadingIndicator.css'
import classnames from 'classnames'

const LoadingIndicator = ({ className, visible, children }) => (
  <div className={classnames(
    styles.loadingIndicator,
    className,
    {
      [styles.visible]: visible
    }
  )}>
    {children}
  </div>
)

LoadingIndicator.defaultProps = {
  children: 'Aan het laden'
}

LoadingIndicator.propTypes = {
  children: PropTypes.node,
  visible: PropTypes.bool,
  className: PropTypes.string
}

export default LoadingIndicator
